<template>
  <div class="input-field" :class="field">
    <i v-if="icon" class="icon" :class="icon"></i>
    <div class="input-field__fill">
      <input
        :id="name"
        class="input-field__input"
        :class="customClass"
        :type="type"
        :name="name"
        :value="value"
        :placeholder="name"
        @input="$emit('input', $event.target.value)"
        @keydown.enter.prevent="onEnter"
      />
      <label class="input-field__label" :for="name">{{ label }}</label>
      <span v-if="info && !hasError" class="info">{{ info }}</span>
      <span v-if="hasError" class="error">{{ hasError }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Input",
  props: {
    field: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    customClass: {
      type: String,
      required: false
    },
    value: {
      type: String,
      default: null
    },
    onEnter: {
      type: Function,
      required: false
    },
    info: {
      type: String,
      default: null
    },
    hasError: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
.input-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0.5em;
  &__fill {
    position: relative;
    width: 100%;
  }
  i {
    width: 1.5em;
    height: 1.5em;
    margin-right: 1em;
  }
  &__input {
    width: 100%;
    padding: 1em 0 5px;
    border: 0;
    border-radius: 0;
    outline: 0;
    box-shadow: none;
    font-size: 1.6rem;
    color: black;
    background-color: transparent;
    border-bottom: 1px solid $whitegray;
    &::placeholder {
      opacity: 0;
      transition: $transition;
    }
    &:placeholder-shown:not(:focus)::placeholder {
      opacity: 0;
    }
    &:placeholder-shown:not(:focus) + label {
      font-size: 1.4rem;
      transform: translateY(15px);
      color: $gray;
    }
    &:focus {
      border-bottom: 1px solid $lightred;
    }
  }
  &__label {
    position: absolute;
    top: 0;
    left: 0;
    transform: translateY(0);
    font-size: 1.2rem;
    pointer-events: none;
    color: $lightred;
    transition: $transition;
  }
  .info {
    font-size: 1.2rem;
  }
}
</style>
